<template>
  <div class="content-editor-modal">
    <button
      type="button"
      class="content-editor-modal__close"
      aria-label="Fermer"
      @click="$emit('close')"
    >
      <i class="fa fa-times"></i>
    </button>

    <header class="content-editor-modal__header">
      <h3>{{ title }}</h3>
      <slot name="header-actions" />
    </header>

    <div class="content-editor-modal__body">
      <slot />
    </div>

    <footer v-if="$slots.footer" class="content-editor-modal__footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ContentEditorModal',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  emits: ['close']
}
</script>

<style lang="scss">
.content-editor-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 96vw;
  max-width: 960px;
  height: auto;
  max-height: 90vh;
  margin: 0 auto;
  padding: 1.5rem 1.75rem 1.25rem;
  overflow: hidden;
  color: #161616;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  box-shadow: 0 22px 54px rgba(17, 24, 39, 0.22);
}

.content-editor-modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  color: #9ca3af;
  background: transparent;
  border: 0;
  border-radius: 999px;
  font-size: 1.35rem;
  line-height: 1;
}

.content-editor-modal__close:hover,
.content-editor-modal__close:focus {
  color: #111827;
  background: #f3f4f6;
  outline: none;
}

.content-editor-modal__header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-right: 2.75rem;
}

.content-editor-modal__header h3 {
  margin: 0 0 1.25rem;
  color: #121212;
  font-size: 1.55rem;
  font-weight: 700;
  line-height: 1.2;
}

.content-editor-modal__body {
  flex: 1 1 auto;
  min-height: 0;
  padding-right: 0.35rem;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}

.content-editor-modal__footer {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.content-editor-modal__footer-options,
.content-editor-modal__footer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.85rem;
}

.content-editor-modal__status-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  font-size: 0.95rem;
  font-weight: 600;
}

.content-editor-modal__button {
  min-width: 7.5rem;
  min-height: 2.15rem;
  padding: 0.35rem 0.95rem;
  color: #374151;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.2;
}

.content-editor-modal__button:hover {
  background: #f9fafb;
}

.content-editor-modal__button--primary {
  color: #fff;
  background: #358c4e;
  border-color: #358c4e;
}

.content-editor-modal__button--primary:hover {
  background: #2f7d46;
  border-color: #2f7d46;
}

.content-editor-modal__button--danger {
  color: #b91c1c;
  border-color: #fecaca;
}

.content-editor-modal__button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@media (max-width: 860px) {
  .content-editor-modal {
    width: calc(100vw - 2rem);
    max-height: 90vh;
    padding: 2.5rem 1rem 1rem;
  }

  .content-editor-modal__header {
    align-items: flex-start;
    padding-right: 0;
  }

  .content-editor-modal__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .content-editor-modal__footer-options,
  .content-editor-modal__footer-actions {
    width: 100%;
  }

  .content-editor-modal__footer-actions {
    justify-content: flex-end;
  }
}
</style>
